module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu01-b700e4038b7a7d1a0a8123409be329f4.png";